const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) window.fbq(...args);
};

// ── Item shape ────────────────────────────────────────────────────────────────
const toPixelContent = (product, quantity = 1) => ({
  id: product._id || product.id,
  quantity,
  item_price: product.sellPrice || product.price || 0,
});

// ── Page view ─────────────────────────────────────────────────────────────────
export const pixelPageView = () => fbq("track", "PageView");

// ── Product events ─────────────────────────────────────────────────────────────
export const pixelViewContent = (product) =>
  fbq("track", "ViewContent", {
    content_ids: [product._id || product.id],
    content_name: product.name,
    content_category: product.category?.name || product.category || "Grocery",
    content_type: "product",
    currency: "INR",
    value: product.sellPrice || product.price || 0,
  });

export const pixelAddToCart = (product, quantity = 1) =>
  fbq("track", "AddToCart", {
    content_ids: [product._id || product.id],
    content_name: product.name,
    content_type: "product",
    currency: "INR",
    value: (product.sellPrice || product.price || 0) * quantity,
  });

// ── Checkout funnel ────────────────────────────────────────────────────────────
export const pixelInitiateCheckout = (cartItems, cartTotal) =>
  fbq("track", "InitiateCheckout", {
    content_ids: cartItems.map((i) => (i.productId?._id || i.productId || i._id)),
    contents: cartItems.map((i) => toPixelContent(i.productId || i, i.quantity)),
    currency: "INR",
    value: cartTotal,
    num_items: cartItems.reduce((sum, i) => sum + (i.quantity || 1), 0),
  });

export const pixelPurchase = (orderId, cartItems, revenue) =>
  fbq("track", "Purchase", {
    content_ids: cartItems.map((i) => (i.productId?._id || i.productId || i._id)),
    contents: cartItems.map((i) => toPixelContent(i.productId || i, i.quantity)),
    content_type: "product",
    currency: "INR",
    value: revenue,
    order_id: orderId,
    num_items: cartItems.reduce((sum, i) => sum + (i.quantity || 1), 0),
  });

// ── Search ────────────────────────────────────────────────────────────────────
export const pixelSearch = (searchTerm) =>
  fbq("track", "Search", { search_string: searchTerm });

// ── Auth ──────────────────────────────────────────────────────────────────────
export const pixelCompleteRegistration = () =>
  fbq("track", "CompleteRegistration");
